import React from "react"
import PricingBox from "./PricingBox"

function PricingPanel({
  i18n,
  pricings,
  locale,
  configuratorUrl,
  currencyTags,
  selectArrowIcon,
}) {
  return (
    <div>
      <div className="pricing-box-header-wrapper">
        <h1 className="pricing-header" style={{ whiteSpace: "pre-line" }}>
          {i18n.sample_front_pricings}
        </h1>
        <div className="mobile-scroll-buttons-container">
          {pricings.map((pricing) => (
            <div
              onClick={() => {
                const e = document.querySelector(`#pricing-box-${pricing.id}`)
                e.scrollIntoView({ behavior: "smooth" })
              }}
              className="mobile-scroll-button"
              key={pricing.id}
            >
              <div className="mobile-scroll-button-img-wrapper">
                {pricing.icon && <img src={pricing.icon.url} />}
              </div>
              {pricing.name}
            </div>
          ))}
        </div>
      </div>
      {pricings.map((pricing) => (
        <PricingBox
          currencyTags={currencyTags}
          configuratorUrl={configuratorUrl}
          key={pricing.id}
          i18n={i18n}
          locale={locale}
          pricing={pricing}
          selectArrowIcon={selectArrowIcon}
        />
      ))}
    </div>
  )
}

export default PricingPanel
